import { BookOpen } from 'lucide-react';
import { PRODUCTS, productUnitShort } from '../../game/constants.js';

const money = (value) => `$${Math.max(0, Number(value || 0)).toLocaleString()}`;

function Price({ label, value, productId }) {
  return <span className={value == null ? 'muted' : ''}><small>{label}</small><strong>{value == null ? '—' : `${money(value)}/${productUnitShort(productId)}`}</strong></span>;
}

export function V2NotebookWindow({ gameState }) {
  const entries = Object.values(gameState?.marketNotebook || {})
    .filter((entry) => entry?.locationId)
    .sort((a, b) => Number(b.day || 0) - Number(a.day || 0) || String(a.locationName || '').localeCompare(String(b.locationName || '')));

  return <div className="v2-notebook-window">
    <header className="v2-window-section-heading"><BookOpen /><div><span>VISITED MARKETS ONLY</span><strong>Last-seen prices and dealer notes</strong></div></header>
    {entries.length ? <div className="v2-notebook-list">{entries.map((entry) => {
      const dealer = entry.kind === 'dealer';
      const dealerLines = Array.isArray(entry.dealerLines) ? entry.dealerLines : [];
      return <article key={entry.locationId} className={dealer ? 'dealer' : 'market'}>
        <header><div><span>{dealer ? 'DEALER' : 'MARKET'}</span><h3>{entry.locationName}</h3></div><time>DAY {entry.day}</time></header>
        {dealer ? <div className="v2-notebook-dealer">{dealerLines.length ? dealerLines.map((line, index) => <div key={`${entry.locationId}-${index}`}><small>{line.label || 'Offer'}</small><strong>{line.value || '—'}</strong>{line.detail && <p>{line.detail}</p>}</div>) : <p>No useful quote was available when you stopped by.</p>}</div> : <div className="v2-notebook-products">{PRODUCTS.map((product) => {
          const buy = entry.buyPrices?.[product.id];
          const sell = entry.sellPrices?.[product.id];
          if (buy == null && sell == null) return null;
          return <div key={product.id}><b>{product.name}</b><Price label="BUY" value={buy} productId={product.id} /><Price label="SELL" value={sell} productId={product.id} /></div>;
        })}</div>}
      </article>;
    })}</div> : <div className="v2-window-unavailable"><BookOpen /><strong>Nothing useful yet.</strong><span>Visit a market or specialty dealer and the latest quote will show up here.</span></div>}
  </div>;
}
